import Vue from 'vue';
import VueRouter from 'vue-router';
import VueCookies from 'vue-cookies';
import UUID from 'vue-uuid';
import VModal from 'vue-js-modal'

import titleMixin from './mixins/titleMixin'

import App from './App.vue';

// ROUTER VIEWS
import Home from './views/Home.vue';

Vue.config.productionTip = false;

Vue.use(VueRouter);
Vue.use(VueCookies);
Vue.use(UUID);
Vue.use(VModal);

Vue.$cookies.config(-1);

Vue.mixin(titleMixin)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/prompt/:pid?',
    name: 'Prompt',
    component: () => import('./views/Prompt.vue')
  },
  {
    path: '/promptGen',
    name: 'PromptGen',
    component: () => import('./views/PromptGen.vue')
  },
  {
    path: '/response/:rid',
    name: 'Response',
    component: () => import('./views/SharedResponse.vue')
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('./views/About.vue')
  },
  {
    path: '/instructions',
    name: 'Instructions',
    component: () => import('./views/Instructions.vue')
  },
  {
    path: '/privacy',
    name: 'Privacy',
    component: () => import('./views/Privacy.vue')
  }
]

const router = new VueRouter({routes: routes,
  scrollBehavior () {
    return { x: 0, y: 0 }
  }
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
